import { CreditCardDownload, CreditCardUpload } from "untitledui-js-base";
import { formatToCurrency } from "utils/currency";
import { Button, ButtonSize, ButtonVariant } from "shared/components";

interface Money {
  cents: number;
  currency: string;
}

interface TransactionSectionProps {
  amount: Money;
  accountType?: string;
  maskedNumber: string;
  billingDate: string;
  onChangeDay: () => void;
  onChangeBankAccount: () => void;
}

const ArrowIconWrapper = ({ isPayout }: { isPayout: boolean }) => {
  return (
    <div
      className={`rounded-full ${
        isPayout ? "bg-success-50" : "bg-danger-50"
      } p-2`}
    >
      {isPayout ? (
        <CreditCardUpload size="24" className="stroke-success-700" />
      ) : (
        <CreditCardDownload size="24" className="stroke-primary-500" />
      )}
    </div>
  );
};

const ChangePayDayButton = ({
  date,
  onChange
}: {
  date: string;
  onChange: () => void;
}) => {
  return (
    <div className="w-auto text-right space-y-2">
      <div className="text-right text-sm font-medium text-content-400">
        On {date}
      </div>

      <Button
        onClick={onChange}
        variant={ButtonVariant.TEXT}
        size={ButtonSize.SM}
      >
        Change billing day
      </Button>
    </div>
  );
};

export const TransactionSection = ({
  amount,
  accountType,
  maskedNumber,
  onChangeDay,
  onChangeBankAccount,
  billingDate
}: TransactionSectionProps) => {
  const isPayout = amount.cents > 0;
  const title = isPayout ? "Upcoming payout" : "Upcoming charge";

  return (
    <div className="flex gap-4 w-full">
      <div className="w-1/2 rounded-lg border bg-white p-6 animate-appear">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-4">
            <ArrowIconWrapper isPayout={isPayout} />
            <div className="space-y-1">
              <p className="text-sm font-medium text-content-300">{title}</p>
              <p className="text-xl font-bold text-content-1000">
                {`${isPayout ? "+" : ""}${formatToCurrency(amount)}`}
              </p>
            </div>
          </div>
          <ChangePayDayButton date={billingDate} onChange={onChangeDay} />
        </div>
      </div>

      <div className="w-1/2 rounded-lg border bg-white p-6 flex justify-between items-center">
        <div className="space-y-2">
          <p className="text-sm font-medium text-content-300">Bank account</p>
          <p className="text-sm font-bold text-content-1000">
            {accountType
              ? `${accountType} **** ${maskedNumber}`
              : "Not selected"}
          </p>
        </div>
        <Button
          onClick={onChangeBankAccount}
          variant={ButtonVariant.BASE}
          size={ButtonSize.SM}
        >
          Change
        </Button>
      </div>
    </div>
  );
};
